import React from 'react';
import ClayLayout from '@clayui/layout';
import '../../components/MembershipForm/MembershipFormComponent.css';
import {
    Control,
    FieldErrors,
    FieldValues,
    UseFormRegister,
    UseFormSetValue,
    UseFormWatch,
    DeepMap,
    UseFormGetValues
} from 'react-hook-form';
import GlobalInput from '../../generic-components/input/GlobalInput';
import { useEffect } from 'react';
import { formForMatchMakingFields } from './MMAuthConfig';
import MatchMakingCustomSelect from './MatchMakingCustomSelect';

interface ExpansionProps {
    formErrors: FieldErrors<FieldValues>;
    control: Control<FieldValues, any>;
    register: UseFormRegister<FieldValues>;
    watch: UseFormWatch<FieldValues>;
    reset: (values?: FieldValues) => void;
    setValue: UseFormSetValue<FieldValues>;
    getValues: UseFormGetValues<FieldValues>;
    touchedFields: DeepMap<FieldValues, boolean>;
    setError: (name: string, error: { type: string; message: string }) => void; // Updated type for setError
    clearErrors: (name?: string) => void; // Updated type for clearErrors
}

const MatchMakingFormComponent: React.FC<ExpansionProps> = ({
    watch,
    control,
    formErrors,
    register,
    setError,
    clearErrors,
    getValues,
    setValue,
}) => {
    const email = watch('emailAddress');
    // Prefill from sessionStorage when available
    useEffect(() => {
        try {
            const raw = sessionStorage.getItem('dcip_member_prefill');
            if (!raw) return;
            const data = JSON.parse(raw || '{}') || {};
            const apiToFormMap: Record<string, string> = {
                emailAddress: 'emailAddress',
                membershipNumber: 'membershipNo',
                mobileNumber: 'mobileNumber',
                fullName: 'customerName',
                companyName: 'company',
            };
            Object.entries(apiToFormMap).forEach(([apiKey, formKey]) => {
                const value = data?.[apiKey as keyof typeof data];
                if (value != null && value !== '') {
                    setValue(formKey as any, value, { shouldValidate: true, shouldDirty: false });
                }
            });
        } catch (e) {
            console.warn('Prefill parse error', e);
        }
    }, [setValue]);

    const validateEmail = () => {
        let emailError = '';
        if (email) {
            if (!/\S+@\S+\.\S+/.test(email)) {
                emailError = 'Invalid email format';
            }
        }
        return emailError;
    };

    return (
        <>
            <ClayLayout.Row justify="start">
                {formForMatchMakingFields.map((input) => {
                    return (
                        <ClayLayout.Col
                            sm={12}
                            md={input.type === 'textarea'? 12:6}
                            lg={input.type === 'textarea'? 12:6}
                            xl={input.type === 'textarea'? 12:6}
                            key={input.name}
                        >
                            { input.type  === 'select' ? (
                                <MatchMakingCustomSelect
                                    control={control}
                                    label={input.label}
                                    name={input.name}
                                    placeholder={input.placeholder}
                                    required={true}
                                    disabled={false}
                                    // defaultValue={defaultValue}
                                    options={[]}
                                    errors={formErrors}
                                    errorTitle={input.errorText}
                                />
                            ):input.type === 'textarea' ? (
                                <GlobalInput
                                    type={input.type}
                                    label={input.label}
                                    placeholder={input.placeholder}
                                    name={input.name}
                                    register={register}
                                    errors={formErrors}
                                    component="textarea"
                                    required={true}
                                />
                            ) : (
                                <div className="form-field">
                                    <GlobalInput
                                        type={input.type}
                                        label={input.label}
                                        placeholder={input.placeholder}
                                        name={input.name}
                                        register={register}
                                        errors={formErrors}
                                        required={true}
                                        disabled={false}
                                        onBlur={(event) => {
                                            let value = event.target.value.trim();
                                            let errorMessage = validateEmail();
                                            if (
                                                input.name === 'emailAddress' && errorMessage
                                            ) {
                                                setError(input.name, {
                                                    type: 'manual',
                                                    message: errorMessage
                                                });
                                            }
                                            else if (
                                                input.name === 'userName' &&
                                                !/^[a-zA-Z0-9\._-]+$/.test(value)
                                            ) {
                                                errorMessage =
                                                    'Invalid User name';
                                                setError(input.name, {
                                                    type: 'manual',
                                                    message: errorMessage
                                                });
                                            } else if (
                                                input.name === 'verifyPassword' &&
                                                value !== getValues('password')
                                            ) {
                                                errorMessage = 'Passwords do not match.';
                                                setError(input.name, {
                                                    type: 'manual',
                                                    message: errorMessage
                                                });
                                                return;
                                            } else {
                                                clearErrors(input.name);
                                            }
                                        }}
                                    />
                                </div>
                            )}
                        </ClayLayout.Col>
                    );
                })}
            </ClayLayout.Row>
        </>
    );
};

export default MatchMakingFormComponent;
